module.exports = __webpack_public_path__ + "static/media/ephippiger_ephippiger_006_APA.00171bfe.png";